module.exports = __webpack_public_path__ + "store/img/paw_print.0909ba3c.png";